// markerSubCategoryMap.ts
export interface QuestionOption {
  code: string;
  value: string;
}

export const SUBCATEGORY_QUESTION_MAP: Record<string, QuestionOption[]> = {
  workProfile: [
    { code: 'is_leadership_role_in_large_company', value: 'Leadership Role in Large Company' },
    { code: 'is_leadership_role_in_500_company', value: 'Leadership Role in Fortune 500 Company' },
    { code: 'work_experience', value: 'Work Experience' },
    { code: 'is_leadership_role_in_a_listed_company', value: 'Leadership Role in Listed Company' },
    { code: 'is_leadership_role_in_sme_company', value: 'Leadership Role in SME Company' },
    { code: 'is_growing_startup_founder', value: 'Growing Startup Founder' },
    { code: 'is_mid_senior_role_in_fortune_company', value: 'Mid / Senior Role in Fortune Company' },
    { code: 'director_or_board_member', value: 'Director or Board Member' }
  ],

  demographics: [
    { code: 'age', value: 'Age' },
    { code: 'genderCode', value: 'Gender' },
    { code: 'isSpouseSameInstitute', value: 'Spouse also from same Institute' },
    { code: 'isSiblingSameInstitute', value: 'Sibling also from same Institute' },
    { code: 'StudiedAbroad', value: 'Study Abroad' },
    { code: 'CurrentlyAbroad', value: 'Currently Abroad' },
    { code: 'LivedAbroadandBack', value: 'Lived Abroad and Back' },
    { code: 'DidnotTakeEducationloan', value: 'Did not Take Education loan' },
    { code: 'wealthyNeighborhoodAddress', value: 'Wealthy Neighborhood' }
  ],

  positionStrength: [
    { code: 'celebrity', value: 'Celebrity' },
    { code: 'wealthyfamily', value: 'Wealthy Family' },
    { code: 'politicalConnection', value: 'Political Connection' },
    { code: 'influentialPositionOfPower', value: 'Influential Position of Power' },
    { code: 'ownsLuxuryCar', value: 'Owns Luxury Car' },
    { code: 'investedinaCompany', value: 'Invested in a Company' },
    { code: 'featuredinHighFortuneRichestList', value: 'Featured in Fortune Richest List' },
    { code: 'featuredinHighTaxPayerList', value: 'Featured in High Tax Payer List' },
    { code: 'mediaMentions', value: 'Media Mentions' },
    { code: 'donatedAnyCauseInPast', value: 'Donated to any cause in Past' },
    { code: 'donatedToOtherInstitutes', value: 'Donated to other Institutes' },
    { code: 'donatedInPast', value: 'Donated in Past' },
    { code: 'recruitedInPast', value: 'Recruited in Past' },
    { code: 'recruitingFromOtherInstitutes', value: 'Recruiting from other Institutes' }
  ],

  affinity: [
    { code: 'instituteSocialMedia', value: "Institute’s Social Media" },
    { code: 'donationPledges', value: 'Donation Pledges' },
    { code: 'recognitionbyInstitute', value: 'Recognition by Institute' },
    { code: 'managementInteractions', value: 'Management Interactions' },
    { code: 'viewAboutInstitute', value: 'Views about the institute' },
    { code: 'admissionReferralsManual', value: 'Admission Referrals' },
    { code: 'isChildSameInstitute', value: 'Child studying in same institute' },
    { code: 'receivedScholarship', value: 'Received Scholarship from Institute' },
    { code: 'benefitsAvailed', value: 'Benefits Availed' },
    { code: 'negativeExperience', value: 'Negative Experience' }
  ],

  influence: [
    { code: 'officeBearerofAlumniAssociation', value: 'Office Bearer of Alumni Association' },
    { code: 'positionHolderdursingInstitute', value: 'Position holders during time at institute' },
    { code: 'popularityinBatch', value: 'Popular in Batch' },
    { code: 'helpedinAdmissions', value: 'Helped in Admissions' }
  ],

  digitalCampaign: [
    { code: 'engagedWithDonorCampaigns', value: 'Engaged with Donor Campaigns' },
    { code: 'engagedWithRecruiterCampaigns', value: 'Engaged with Recruiter Campaigns' },
    { code: 'engagedWithGeneralInstituteCampaigns', value: 'Engaged with General Institute Update Campaigns' },
    { code: 'engagedWithRecognitionCampaigns', value: 'Engaged with Recognition Campaigns' },
    { code: 'engagedWithNetworkingCampaigns', value: 'Engaged with Networking Campaigns' },
    { code: 'engagedWithEmotionalConnectCampaigns', value: 'Engaged with Emotional Connect Campaigns' },
    { code: 'engagedWithRecreationEventsCampaigns', value: 'Engaged with Recreation & Events Campaigns' },
    { code: 'engagedWithLearningAndDevelopmentCampaigns', value: 'Engaged with Learning & Development Campaigns' },
    { code: 'industryUpdates', value: 'Industry Updates' },
    { code: 'engagedWithHumorCampaigns', value: 'Engaged with Humor Campaigns' }
  ],

  general: [
    { code: 'activeOnWtapp', value: 'Active on WhatsApp' },
    {code: 'respondedToFeedBackSurvey', value: 'Responded to Feedback Survey'},
    { code: 'respondedCallForInformation', value: 'Responded Call For Information' },
    { code: 'respondedCallForProfileCreation', value: 'Responded Call For Profile Creation' },
    { code: 'respondedCallForEventInvitation', value: 'Responded Call For Event Invitation' },
    { code: 'respondedCallForRecruitmentCampaign', value: 'Responded Call For Recruitment Campaign' },
    { code: 'respondedCallForDonationCampaign', value: 'Responded Call For Donation Campaign' },
    { code: 'hadConversationWithPlacememtCell', value: 'Had Conversation With Placement Cell' },
    { code: 'hadConversationWithRegardingFundraise', value: 'Had Conversation Regarding Fundraise' }
  ]
};
